import request from '@/utils/request'

// 分页查询活动列表
export function page(query) {
  return request({
    url: '/video/popWindow/list',
    method: 'get',
    params: query
  })
}

export function detail(query) {
  return request({
    url: `/video/popWindow/detail`,
    method: 'get',
    params: query
  })
}

export function add(data) {
  return request({
    url: '/video/popWindow/add',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: '/video/popWindow/update',
    method: 'post',
    data: data
  })
}

export function del(data) {
  return request({
    url: `/video/popWindow/del`,
    method: 'post',
    data: data
  })
}
